export const getFbclidFromURL = () => {
  if (typeof window === 'undefined') return null;
  
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('fbclid');
};

export const setFbclidCookie = (fbclid, days = 30) => {
  if (typeof document === 'undefined' || !fbclid) return;
  
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  
  document.cookie = `fbclid=${fbclid}; ${expires}; path=/; SameSite=Lax; Secure`;
};

export const getFbclidCookie = () => {
  if (typeof document === 'undefined') return null;
  
  const name = "fbclid=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
};

export const trackFbclid = () => {
  const fbclidFromURL = getFbclidFromURL();
  
  if (fbclidFromURL) {
    setFbclidCookie(fbclidFromURL);
    return fbclidFromURL;
  }
  
  return getFbclidCookie();
};